var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ai-product-requests-wrapper" },
    [
      _c("p", { staticClass: "title" }, [
        _vm._v(
          " " + _vm._s(_vm.$t("aiAssistancePage.buyAdditionalAiRequests")) + " "
        ),
      ]),
      _vm._l(_vm.products, function (product) {
        return _c("ai-requests-product-card", {
          key: product.id,
          staticClass: "mb-3",
          attrs: {
            value: product.value,
            "product-id": product.id,
            price: product.price,
          },
          on: {
            "buy-now": function ($event) {
              return _vm.buyNow($event)
            },
          },
        })
      }),
      _c("ai-requests-info-text", {
        staticStyle: { "margin-top": "13px" },
        attrs: {
          text: _vm.$t("aiAssistancePage.thisCreditWillBeUtilizedFirst"),
        },
      }),
      _c("dialog-product-thank-you", {
        attrs: { visible: _vm.dialogThankYouVisible },
        on: { close: _vm.onCloseDialogThankYou },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }